import { Controller } from "@hotwired/stimulus"

// Takes its element off the page once the operator has had time to read it.
// Lives on the alert and not on the flash region because the region's two
// alerts don't share a fate — the notice goes, the error stays.
export default class extends Controller {
  static values = { delay: Number }

  connect() {
    this._timer = setTimeout(() => this.element.remove(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this._timer)
  }
}
